import React from 'react';
import { Link } from 'react-router-dom';
import LandingNav from '../components/LandingNav';
import Footer from '../components/Footer';

// Account & data deletion instructions for Go Doorly, LLC. Public route,
// no auth — this is the URL supplied to the Apple App Store and Google
// Play ("Delete Account URL" / App access) so users (including those who
// no longer have the app installed) can find how to delete their account.
export default function DeleteAccount() {
  return (
    <div className="min-h-screen bg-white">
      {/* 🔑 The landing page's header and menu (Jesse, 2026-10-19): it sits in the flow and pads for the safe area,
          so the top of the page is never under it, on the web or in the app. */}
      <LandingNav />
      <main className="max-w-3xl mx-auto px-6 pt-10 pb-12">
        <h1 className="text-3xl font-bold text-black mb-2">Delete Your Account</h1>
        <p className="text-sm text-gray-500 mb-8">
          Go Doorly, LLC · NMLS #2764749
        </p>

        <section className="space-y-6 text-sm text-gray-700 leading-relaxed">
          <div>
            <p>
              You can request deletion of your Doorly account and associated personal
              information at any time. There are two ways to do this:
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-black mb-2">Option 1 — Delete in the app</h2>
            <ol className="list-decimal pl-6 mt-2 space-y-1">
              <li>
                Sign in at{' '}
                <a href="https://app.godoorly.com" className="text-blue-600 underline">
                  app.godoorly.com
                </a>{' '}
                (or in the Doorly mobile app).
              </li>
              <li>Go to <strong>Settings</strong>.</li>
              <li>Tap <strong>Delete Account</strong> and confirm.</li>
            </ol>
          </div>

          <div>
            <h2 className="text-lg font-bold text-black mb-2">Option 2 — Request by email</h2>
            <p>
              If you no longer have access to the app, email{' '}
              <a href="mailto:support@godoorly.com" className="text-blue-600 underline">
                support@godoorly.com
              </a>{' '}
              from the email address on your account with the subject line
              "Delete My Account." We will verify your identity and process your
              request within <strong>30 days</strong>.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-black mb-2">What is deleted</h2>
            <p>
              When your request is processed, we deactivate your account and remove
              the personal identifiers associated with it — including your name, email
              address, and login credentials — so the account can no longer be accessed.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-black mb-2">What is retained, and why</h2>
            <p>
              Doorly is a licensed mortgage lender. Federal and state law require us to
              retain certain loan and application records for a set period after your
              last activity — including under the Equal Credit Opportunity Act
              (Regulation B), the Home Mortgage Disclosure Act (Regulation C), the
              Gramm-Leach-Bliley Act, and other lending recordkeeping rules. We retain
              these records only for as long as the law requires, keep them secured, and
              delete them in accordance with our retention schedule once the required
              period ends. We do not sell your personal information.
            </p>
          </div>

          <div>
            <p>
              For more detail on how we handle your information, see our{' '}
              <Link to="/privacy" className="text-blue-600 underline">Privacy Policy</Link>.
              Questions? Contact{' '}
              <a href="mailto:support@godoorly.com" className="text-blue-600 underline">
                support@godoorly.com
              </a>.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
